import baseHttp from './baseHttp';

export const getRatings = (restaurantId, params) =>
  baseHttp.get(`/api/v1/restaurants/${restaurantId}/ratings`, { params }).then((r) => r.data);
